import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
        editMode: {
            type: Boolean,
            default: false,
        },
        mappingData: {
            type: Object,
            default: null,
        },
        prefill: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            form: {
                np_status_code: '',
                np_status_name: '',
                crm_status_id: null,
                is_active: true,
                exception_status_ids: [],
            },
            npCodesList: [],
            crmStatusesList: [],
        };
    },
    computed: {
        ...mapGetters({
            npCodes: 'npAutomation/npCodes',
            crmStatuses: 'npAutomation/crmStatuses',
        }),
    },
    watch: {
        npCodes(data) {
            this.npCodesList = [];
            if (data) {
                for (let key in data) {
                    this.npCodesList.push({ id: key, title: `${key} - ${data[key]}` });
                }
            }
            this.ensureNpStatusName();
        },
        crmStatuses(data) {
            this.crmStatusesList = data || [];
        },
    },
    created() {
        this.getNpCodes();
        this.getCrmStatuses();
        this.applyInitialForm();
    },
    methods: {
        applyInitialForm() {
            Object.assign(this.form, {
                np_status_code: '',
                np_status_name: '',
                crm_status_id: null,
                is_active: true,
                exception_status_ids: [],
            });

            const prefill = this.prefill && typeof this.prefill === 'object' ? this.prefill : {};
            if (prefill.np_status_code !== undefined && prefill.np_status_code !== null) {
                this.form.np_status_code = String(prefill.np_status_code);
            }
            if (prefill.np_status_name) {
                this.form.np_status_name = String(prefill.np_status_name);
            }
            if (prefill.crm_status_id !== undefined) {
                this.form.crm_status_id = prefill.crm_status_id;
            }
            if (typeof prefill.is_active === 'boolean') {
                this.form.is_active = prefill.is_active;
            }
            if (Array.isArray(prefill.exception_status_ids)) {
                this.form.exception_status_ids = prefill.exception_status_ids;
            }

            if (this.mappingData) {
                this.form.np_status_code = String(this.mappingData.np_status_code || '');
                this.form.np_status_name = String(this.mappingData.np_status_name || '');
                this.form.crm_status_id = this.mappingData.crm_status_id;
                this.form.is_active = Boolean(this.mappingData.is_active);
                if (Array.isArray(this.mappingData.exception_status_ids)) {
                    this.form.exception_status_ids = this.mappingData.exception_status_ids;
                } else {
                    this.form.exception_status_ids = this.mappingData.exceptions?.map(e => e.crm_status_id) || [];
                }
            }

            this.ensureNpStatusName();
        },
        ensureNpStatusName() {
            const code = this.form.np_status_code;
            if (code && !this.form.np_status_name && this.npCodes && this.npCodes[code]) {
                this.form.np_status_name = this.npCodes[code];
            }
        },
        onNpCodeChange(code) {
            if (code && this.npCodes[code]) {
                this.form.np_status_name = this.npCodes[code];
            }
        },
        save() {
            const payload = {
                ...this.form,
            };
            if (this.editMode && this.mappingData) {
                payload.id = this.mappingData.id;
            }
            this.$emit('save', payload);
        },
        closePopup() {
            this.$emit('closePopup');
        },
        ...mapActions({
            getNpCodes: 'npAutomation/getNpCodes',
            getCrmStatuses: 'npAutomation/getCrmStatuses',
        }),
    },
};

